jQuery(document).ready(function ($) {
    $('.search-nav-pop').on('click', function (e) {
        if ($('.breakpoint.tablet-landscape').is(':visible')) {
            e.preventDefault();
            $('.search-bar').addClass('open');
        }
    });

    $('.search-bar-close').on('click', function (e) {
        if ($('.breakpoint.tablet-landscape').is(':visible')) {
            e.preventDefault();
            $('.search-bar').removeClass('open');
        }
    });
});